<template>
    <div>
      <loader :loading="loading"/>
  
      <page-header :title="`Cidades`">
        <template v-slot:breadcrumbs>
          <li>Cidades</li>
        </template>
  
        <template v-slot:actions>
          <div>
            <button class="btn btn-success" @click.prevent="$router.push('/regioes/add')">Nova Região</button>
          </div>
        </template>
      </page-header>
  
      <filters @search="handleSearch(filters, 1)" @clear="clearFilters">
        <form @keyup.enter="handleSearch(filters)">
          <div class="row g-2 mt-2">
            
            <div class="col-2">
              <div>
                <label class="form-label">Estado</label>
                <select class="form-select form-select-sm" v-model="filters.uf" @change="filters.city = ''">
                  <option value="">Todos</option>
                  <option v-for="(uf) in states" v-bind:key="uf.uf" :value="uf.uf">{{ uf.uf}}</option>
                </select>
              </div>
            </div>
  
            <div class="col-3">
              <div>
                <label class="form-label">Cidade</label>
                <select :disabled="!filters.uf" class="form-select form-select-sm" v-model="filters.city">
                  <option value="">Todas</option>
                  <option v-for="city in citiesLocal" v-bind:key="city.name" :value="city.name">{{ city.name }}</option>
                </select>
              </div>
            </div>

          </div>
        </form>
      </filters>
  
      <div class="card bg-white mt-4">
        <div class="card-body p-4">
          <div class="d-flex align-items-center justify-content-end">
            <span class="small text-secondary" v-if="collection.data.length">
              Mostrando {{ collection.data.length }} de {{ collection.total }} registros
            </span>
          </div>
          <div class="table-responsive mt-3">
  
            <table class="table table-striped" v-if="collection.data.length">
              <thead>
              <tr>
                <th>Cidade</th>
                <th>Estado</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="city in collection.data" :key="city.id">
                <td>{{ city.name }}</td>
                <td>{{ city.state }}</td>
                <th>
                  <div class="d-flex align-items-center justify-content-end">
                    <div class="btn-group">
                      <button type="button" class="btn btn-primary btn-sm dropdown-toggle"
                              data-bs-popper-config='{"strategy":"fixed"}' data-bs-toggle="dropdown">
                        Ações
                      </button>
                      <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#" @click.prevent="$router.push(`/regioes/${city.id}`)">Editar</a></li>
                      </ul>
                    </div>
                  </div>
                </th>
              </tr>
              </tbody>
            </table>
  
            <div class="bg-light p-2 rounded-2 text-center" v-else>Nenhum registro encontrado...</div>
  
            <div class="d-flex align-items-center justify-content-center mt-4">
              <paginator
                  :current-page="collection.current_page"
                  :limit-pages="5"
                  :pages="collection.last_page"
                  @page-changed="handleSearch(filters, $event)"
                  v-if="collection.data.length"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import {mapActions, mapState} from "vuex";
  import PageHeader from "@/components/PageHeader.vue";
  import Paginator from "@/components/shared/paginator.vue";
  import Loader from "@/components/shared/loader.vue";
  import Filters from "@/components/shared/Filters.vue";
  import axios from "axios";
  
  export default {
    name: 'clients',
    props: {},
    components: {
      Filters,
      Loader,
      Paginator,
      PageHeader
    },
    data() {
      return {
        loading: false,
        citiesRegions: [],
        citiesFiltered: [],
        filters: {
          uf: '',
          city: ''
        }
      }
    },
    async mounted() {
      await this.getCities();
      this.filters = {
        uf: this.$route.query.uf ?? '',
        city: this.$route.query.city ?? ''
      }
      await this.handleSearch(this.filters, this.$route.query.page ?? 1);
    },
    methods: {
      ...mapActions('Regions', ['getCities','getAll']),
      async handleSearch(filters, page = 1) {
        this.loading = true;
  
        const params = {
          page: page,
          ...filters
        }      
  
        await this.getAll(params).finally(() => {
          this.loading = false;
          this.$urlUtils.assignQueryString(this.$route, params);
          this.$scrollTop();
        });
      },
      clearFilters() {
        this.filters = {
          uf: '',
          city: ''
        }
  
        this.handleSearch(this.filters, 1);
      }
    },
    computed: {
      ...mapState('Regions', ['collection', 'cities']),
      ...mapState('Locations', ['states']),
      citiesLocal(){

        if(!this.filters.uf) {
          return [];
        }

        return this.cities.data.filter((city) => city.uf === this.filters.uf);

      }
    }
  }
  </script>
  <style lang="scss" scoped>
  
  </style>
  